export function areArraysEqual<T>(
    arr1: T[],
    arr2: T[],
    comparator?: (item1: T, item2: T) => boolean,
    childProp?: string,
) {
    if (!comparator) {
        comparator = (item1, item2) => item1 === item2;
    }

    if (arr1.length !== arr2.length) return false;

    const exceptItem = arr1.find((item1) => {
        const item2 = arr2.find((x) => comparator(item1, x));
        if (!item2) {
            return true;
        } else if (childProp) {
            // if childProp given we should check children arrays for equality
            return !areArraysEqual(item1[childProp], item2[childProp], comparator);
        }
    });
    // exceptItem not exists in arr2 (or has different children array), arrays are not equal
    return !exceptItem;
}
